<template>
  <div>
    <v-card flat>
      <v-card-title class="secondary white--text">
        <div class="ma-0">
          <div class="d-flex align-center">
            <v-icon large left color="white">mdi-account-tie</v-icon>
            <p class="subtitle-1 my-0">{{ tableData.Count }} Landlords</p>
            <v-divider
              v-if="showTotPayments"
              vertical
              class="mx-3 my-1"
              color="white"
            ></v-divider>
            <span v-if="showTotPayments" class="subtitle-1">{{
              totalPayments(this.tableData)
            }}</span>
          </div>
        </div>
        <v-spacer></v-spacer>
        <generic-search
          v-model="landlordId"
          label="Search Landlord"
          schema-type="LettingsLandlord"
          :hide-details="true"
          :dark="true"
          @change="handleFilterChange"
        />
      </v-card-title>

      <!-- Table -->
      <v-data-table
        :headers="tableHeaders"
        :items="tableData && tableData.Data ? tableData.Data : []"
        :loading="isLoading"
        :search="search"
        :server-items-length="tableData && tableData.Count ? tableData.Count : 0"
        :options.sync="options"
        :footer-props="{ 'items-per-page-options': [10, 25, 50] }"
        @update:options="handleOptionsUpdate"
        class="elevation-0"
        no-data-text="No landlords found"
        :items-per-page="10"
      >
        <template v-slot:item.LandlordName="{ item }">
          <a class="accent--text" @click="openInfoDialog(item)">{{ item.LandlordName }}</a>
        </template>
        
        <template v-slot:item.LandlordAddress="{ item }">
          <span class="font-weight-light text-caption">{{ item.LandlordAddress }}</span>
        </template>
        
        <template v-slot:item.LandlordAccountBalance="{ item }">
          <span>{{ item | returnDisplayAmount }}</span>
        </template>
        
        <template v-slot:item.LandlordAccountNumber="{ item }">
          <span
            class="font-weight-thin"
            v-if="item.LandlordAccountNumber === 'Bank Details Incomplete'"
          >
            Incomplete
          </span>
          <span class="font-weight-thin" v-else>
            {{ item.LandlordAccountNumber }}
          </span>
        </template>
        
        <template v-slot:item.actions="{ item }">
          <v-menu offset-y left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="secondary"
                dark
                small
                depressed
                v-bind="attrs"
                v-on="on"
                class="text-capitalize"
              >
                Actions
                <v-icon right>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list class="py-0 secondary" dark>
              <v-list-item @click="fetchAccountSummary(item.LandlordID)">
                <v-list-item-title
                  >View account summary</v-list-item-title
                >
                <v-list-item-icon>
                  <v-icon small>mdi-open-in-new</v-icon>
                </v-list-item-icon>
              </v-list-item>
              <v-list-item  @click="applyCharge('Charge', item)">
                <v-list-item-title>
                  Apply Charge</v-list-item-title
                >
                <v-list-item-icon>
                  <v-icon small>mdi-currency-gbp</v-icon>
                </v-list-item-icon>
              </v-list-item>
              <v-list-item  @click="applyCharge('Refund', item)">
                <v-list-item-title>
                  Apply Refund</v-list-item-title
                >
                <v-list-item-icon>
                  <v-icon small>mdi-currency-gbp</v-icon>
                </v-list-item-icon>
              </v-list-item>

              <v-list-item @click="navigateToPaymentRequests(item)">
                <v-list-item-title
                  >View payment requests</v-list-item-title
                >
                <v-list-item-icon>
                  <v-icon small>mdi-folder-plus-outline</v-icon>
                </v-list-item-icon>
              </v-list-item>
              <v-list-item @click="openDialog(item)">
                <v-list-item-title
                  >Contact support regarding this landlord</v-list-item-title
                >
                <v-list-item-icon>
                  <v-icon small>mdi-comment-text-outline</v-icon>
                </v-list-item-icon>
              </v-list-item>
      <v-list-item @click="requestOneOffPayment(item)">
        <v-list-item-title>Request One Off Payment</v-list-item-title>
        <v-list-item-icon>
          <v-icon small>mdi-currency-gbp</v-icon>
        </v-list-item-icon>
      </v-list-item>
      <v-list-item @click="fetchPendingInvoice(item.LandlordID)">
                
                <v-list-item-title
                  >View latest pending invoice</v-list-item-title
                >
                <v-list-item-icon>
                  <v-icon small>mdi-open-in-new</v-icon>
                </v-list-item-icon>
              </v-list-item>
      <v-list-item
                @click.stop="openHistoricInvoicesDialog(item.LandlordID)"
              >
                <v-list-item-title>Download latest remittances</v-list-item-title>
                <v-list-item-icon>
                  <v-icon small>mdi-download</v-icon>
                </v-list-item-icon>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>

    <!-- Pending invoice dialog -->
    <v-dialog v-model="pendingInvoiceDialog" max-width="100%">
      <PendingInvoiceCard
        :invoice="pendingInvoice"
        @closeDialog="closePendingInvoiceDialog"
      />
    </v-dialog>

    <MsgDialog
      :dialog="dialog"
      :details="selectedItem.LandlordName"
      :source="source"
      :OID="selectedItem.LandlordID"
      @closeDialog="closeDialog"
      @msgSent="msgSent"
    />

    <Snackbar
      :snackbarDialog="snackbar"
      :snackbarText="snackbarText"
      :snackbarColor="snackbarColor"
      @closeSnackbar="closeSnackbar()"
      :timeout="timeout"
    />

    <UserInfoDialog
      :dialog="infoDialog"
      :name="selectedItem.LandlordName"
      :email="selectedItem.LandlordEmail"
      :number="selectedItem.LandlordMobile"
      :fullDetails="selectedItem"
      :selectedProperties="selectedProperties"
      :isLoading="infoLoading"
      @closeDialog="closeInfoDialog"
    />

    <v-dialog v-model="accountSummaryPopup" max-width="100%">
      <PersonAccountPopup
        :entries="accountSummary"
        @closeDialog="closeAccountSummaryPopup"
      />
    </v-dialog>
    <v-dialog v-model="applyChargePopup" max-width="500px">
    <ApplyChargeOrRefundForm
        :actionToApply="chargeAction"
        :personID="selectedItem.LandlordID"
        @closeDialog="closeChargePopup"
      />
    </v-dialog>
    <v-dialog v-model="requestOneOffDialog" max-width="500px">
    <RequestPaymentDialog
        :selectedPaymentType="'One off payment'"
        :personID="selectedItem.LandlordID"
        @closeRequestPaymentDialog="closeOneOffRequestPaymentDialog"
      />
    </v-dialog>
    <!-- historic invoices -->
    <v-dialog
      v-model="historicInvoiceDialog"
      width="500px"
      transition="dialog-transition"
    >
      <HistoricInvoicesCard
        :invoices="selectedHistoricInvoices"
        @closeDialog="closeHistoricInvoiceDialog"
      />
    </v-dialog>
  </div>
</template>

<script>
import { amplifyProxy } from '@/services/directApi'
import MsgDialog from "@/components/Dialogs/MessageDialog"
import UserInfoDialog from "@/components/Dialogs/UserInfoDialog"
import Snackbar from "@/components/Snackbars/TheSnackbar"
import PersonAccountPopup from "@/components/BaseComponents/PersonAccountPopup.vue"
import ApplyChargeOrRefundForm from "../PaymentRequests/ApplyChargeOrRefundForm.vue"
import RequestPaymentDialog from '../PaymentRequests/PaymentRequestDialog.vue'
import HistoricInvoicesCard from "@/components/OutgoingPayments/HistoricInvoicesCard.vue"
import PendingInvoiceCard from "@/components/OutgoingPayments/PendingInvoiceCard.vue"
import GenericSearch from '@/components/CloudSearch/GenericSearch.vue'

export default {
  components: {
    MsgDialog,
    UserInfoDialog,
    Snackbar,
    PersonAccountPopup,
    ApplyChargeOrRefundForm,
    RequestPaymentDialog,
    HistoricInvoicesCard,
    PendingInvoiceCard,
    GenericSearch
  },
  props: {
    tableData: {
      type: Object,
      required: true
    },
    headers: {
      type: Array,
      required: true
    },
    showTotPayments: {
      type: [Boolean, String],
      default: false
    },
    msg: {
      type: String,
      default: ''
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      source: "Landlords",
      loading: false,
      search: "",
      selectedItem: "",
      dialog: false,
      infoDialog: false,
      snackbar: false,
      snackbarText: "",
      snackbarColor: "",
      timeout: 3000,
      loadingAccountsSummary: false,
      accountSummary: "",
      accountSummaryPopup: false,
      chargeAction: "",
      applyChargePopup: false,
      requestOneOffDialog: false,
      selectedProperties: [],
      infoLoading: false,
      historicInvoiceDialog: false,
      selectedHistoricInvoices: "",
      pendingInvoiceDialog: false,
      pendingInvoice: "",
      loadingPendingInvoice: false,
      options: {
        page: 1,
        itemsPerPage: 10
      },
      tableHeaders: [
        { text: 'Name', value: 'LandlordName', sortable: false },
        { text: 'Address', value: 'LandlordAddress', sortable: false },
        { text: 'Balance', value: 'LandlordAccountBalance', sortable: false },
        { text: 'Account no.', value: 'LandlordAccountNumber', sortable: false },
        { text: 'Actions', value: 'actions', align: 'end', sortable: false }
      ],
      // Filter data
      landlordId: ''
    }
  },
  computed: {
    hasActiveFilters() {
      return this.landlordId
    }
  },
  methods: {
    async fetchPendingInvoice(id) {
      this.loadingPendingInvoice = true

      try {
        const endpoint = `/${this.$store.state.user.ClientName}/outgoingPayments/${id}/invoice/pending`
        const options = {
          headers: {
            token: this.$store.state.user.LoginToken
          }
        }

        const response = await amplifyProxy.get(endpoint, options)
        this.pendingInvoice = response.data
        this.pendingInvoiceDialog = true
      } catch (error) {
        console.error('Error fetching pending invoice:', error)
      } finally {
        this.loadingPendingInvoice = false
      }
    },

    closePendingInvoiceDialog() {
      this.pendingInvoice = ""
      this.pendingInvoiceDialog = false
    },

    async openHistoricInvoicesDialog(personID) {
      try {
        const endpoint = `/${this.$store.state.user.ClientName}/${personID}/invoices/historic`
        const options = {
          headers: {
            token: this.$store.state.user.LoginToken
          }
        }

        const response = await amplifyProxy.get(endpoint, options)
        this.selectedHistoricInvoices = response.data
        this.historicInvoiceDialog = true
      } catch (error) {
        console.error('Error fetching historic invoices:', error)
      }
    },

    closeHistoricInvoiceDialog() {
      this.selectedHistoricInvoices = ""
      this.historicInvoiceDialog = false
    },

    navigateToPaymentRequests(item) {
      this.$router.push({ name: "Payments", params: { id: item.LandlordID } })
    },

    closeSnackbar() {
      this.snackbar = false
    },

    openDialog(item) {
      this.selectedItem = item
      this.dialog = true
    },

    async openInfoDialog(item) {
      this.infoLoading = true

      try {
        const endpoint = `/${this.$store.state.user.ClientName}/${item.LandlordID}/invoices/properties`
        const options = {
          headers: {
            token: this.$store.state.user.LoginToken
          }
        }

        const response = await amplifyProxy.get(endpoint, options)
        this.selectedProperties = response.data
        this.selectedItem = item
        this.infoDialog = true
      } catch (error) {
        console.error('Error fetching properties:', error)
      } finally {
        this.infoLoading = false
      }
    },

    closeDialog() {
      this.dialog = false
    },

    closeInfoDialog() {
      this.selectedProperties = []
      this.infoDialog = false
      this.selectedItem = ""
    },

    msgSent(payload) {
      this.dialog = false
      this.snackbar = true
      this.snackbarColor = payload.color
      this.snackbarText = payload.text
    },

    totalPayments(value) {
      const array = value.Data
      const payments = array.map(val => val.LandlordAccountBalance)
      const total = payments.reduce((acc, val) => acc + val, 0)
      return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP"
      }).format(total)
    },

    async fetchAccountSummary(id) {
      this.loadingPendingInvoice = true

      try {
        const endpoint = `/${this.$store.state.user.ClientName}/company/person/${id}/account`
        const options = {
          headers: {
            token: this.$store.state.user.LoginToken
          }
        }

        const response = await amplifyProxy.get(endpoint, options)
        this.accountSummary = response.data
        this.accountSummaryPopup = true
      } catch (error) {
        console.error('Error fetching account summary:', error)
      } finally {
        this.loadingAccountsSummary = false
      }
    },

    closeAccountSummaryPopup() {
      this.accountSummary = ""
      this.accountSummaryPopup = false
    },

    applyCharge(actionToApply, item) {
      this.chargeAction = actionToApply
      this.selectedItem = item
      this.applyChargePopup = true
    },

    closeChargePopup() {
      this.chargeAction = ""
      this.applyChargePopup = false
    },

    requestOneOffPayment(item) {
      this.selectedItem = item
      this.requestOneOffDialog = true
    },

    closeOneOffRequestPaymentDialog() {
      this.requestOneOffDialog = false
    },
    
    handleOptionsUpdate(newOptions) {
      if (this.search || this.isLoading) return // Don't emit for client-side search or while loading
      
      let type = 'all';
      if (this.msg.includes('bank')) type = 'bankless';
      else if (this.msg.includes('email')) type = 'emailless';
      else if (this.msg.includes('Owing')) type = 'owing';
      else if (this.msg.includes('10%')) type = 'tenPercent';
      
      this.$emit('paginate', type, newOptions.page, newOptions.itemsPerPage, { landlordId: this.landlordId });
    },
    handleFilterChange() {
      // Reset to first page when filters change
      this.options.page = 1;
      this.handleOptionsUpdate(this.options);
    },
    clearAllFilters() {
      this.landlordId = '';
      this.handleFilterChange();
    }
  },
  filters: {
    returnDisplayAmount(val) {
      return val.DisplayLandlordAccountBalance
    },
  },
}
</script>

<style lang="css" scoped>
.position-relative {
  position: relative;
}
</style>